import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { assignOperator, getTripById } from '../../../state/actions/trips'
import { actionCreators } from '../../../state/actions/google_map'
import { getDriversList } from '../../../state/actions/drivers'
import { IActiveTripResponseV2, IStoreState, ISimpleDriverDTO, ITripEdit } from '../../../types'
import { TripStatuses } from '../../../constants/trip-statuses'
import AssignOperatorModal from '.././../../components/trips/management/AssignOperatorModal'
import * as actions from '../../../state/actions/trips'
import * as moment from 'moment'
import * as groupRideActions from '../../../state/actions/group_ride'

export function mapStateToProps(state: IStoreState, ownProps: RouteComponentProps<any>) {
  return {
    isFetching: state.trips.isFetching,
    currentOrganizationId: state.organizations.currentOrgId,
    tripId: ownProps.match.params.tripId,
    trip: state.trips.items[ownProps.match.params.tripId],
    onClose: ownProps.history.goBack,
    operators: Object.values(state.drivers.items)
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    saveData: async (params: ITripEdit): Promise<any> => {
      return await dispatch(actions.saveData(params))
    },

    getTrip: (tripId: string) => dispatch(getTripById(tripId)),

    fetchOperators: (organizationId: string) => {
      return dispatch(
        getDriversList({
          organizationId,
          skip: 0,
          take: 1000
        })
      )
    },
    assignOperator: (trip: IActiveTripResponseV2, operator: ISimpleDriverDTO, isOndemandTrip: boolean) => {
      //TODO figure out why trip.status is some times an array and some times an object
      const tripStatus = trip.lastStatus
      const lastStatus = tripStatus
      const setScheduled = isOndemandTrip ? false : lastStatus !== TripStatuses.SCHEDULED
      const setDispatchAssignedDriver = isOndemandTrip ? true : false

      return dispatch(assignOperator(trip.id, operator, setScheduled, setDispatchAssignedDriver))
    },
    assignScheduledGroupRideOperator: async (id: string, operator: ISimpleDriverDTO, tripId?: string): Promise<any> => {
      return await dispatch(groupRideActions.assignOperator(id, operator, tripId))
    },
    unAssignScheduledGroupRideOperator: async (id: string): Promise<any> => {
      return await dispatch(groupRideActions.unAssignOperator(id))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssignOperatorModal)



// WEBPACK FOOTER //
// ./src/containers/trips/management/AssignOperatorModal.ts